import { couponRoutes } from './coupons.routes'
import { areaRoutes } from './areas.routes'
import { areaTypeRoutes } from './areaTypes.routes'
import { categoriesRoutes } from './categories.routes'
import { rentalRoutes } from './rentals.routes'
import { saleRoutes } from './sales.routes'
import { tagRoutes } from './tags.routes'
import { productRoutes } from './products.routes'
import { bookingRoutes } from './bookings.routes'
import { settingRoutes } from './settings.routes'
import { authRoutes } from './auth'
import { openingHourRoutes } from './openingHours.routes'
import { payoutRoutes } from './payouts.routes'
import { userRoutes } from './users.routes'
import { dashboardRoutes } from './dashboard.routes'
import { fabricRoutes } from './fabrics.routes'
import { conditionRoutes } from './conditions.routes'
import { genderRoutes } from './genders.routes'
import { typeRoutes } from './types.routes'

export const apiRoutes = {
	...tagRoutes,
	...saleRoutes,
	...rentalRoutes,
	...areaRoutes,
	...areaTypeRoutes,
	...categoriesRoutes,
	...couponRoutes,
	...productRoutes,
	...bookingRoutes,
	...settingRoutes,
	...authRoutes,
	...openingHourRoutes,
	...payoutRoutes,
	...userRoutes,
	...dashboardRoutes,
	...fabricRoutes,
	...conditionRoutes,
	...genderRoutes,
	...typeRoutes
}
